import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OnlinePaymentEnum } from 'projects/shared/src/models/global/enums/OnlinePaymentEnum';
import { LookupsService } from 'projects/shared/src/services/lookups.service';
@Component({
  selector: 'app-payment-card-form',
  templateUrl: './payment-card-form.component.html',
  standalone: false,

})
export class PaymentCardFormComponent implements OnInit {
  @Input({ required: true }) service: any;
  @Input() paymentObj: any;
  @Input() files: any;
  dataLoading = false;
  paymentIframeLoader = false;
  paymentProvider: any = OnlinePaymentEnum.Visa_MasterCard;
  referencePaymentUrl: any = null;
  onlinePaymentEnum = OnlinePaymentEnum;

  paymentMethodsLoading = false
  paymentMethods: any[] = []

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    private lookupsService: LookupsService
  ) { }

  ngOnInit(): void {
    this.getPaymentMethodsLookup();
  }

  getPaymentMethodsLookup() {
    this.paymentMethodsLoading = true;
    this.lookupsService.getPaymentMethodsLookup().subscribe((res: any) => {
      this.paymentMethods = res;
      this.paymentProvider = res[0].code
      this.getCopyAndPayId();
      this.paymentMethodsLoading = false;
    }, (err: any) => {
      this.paymentMethodsLoading = false;
    })
  }

  getCopyAndPayId() {
    this.dataLoading = true;
    this.paymentObj.paymentType = this.paymentProvider;
    let formData: any = this.paymentObj;
    if (this.files) {
      formData = new FormData();
      formData.append('data', JSON.stringify(this.paymentObj));
      this.files.forEach(f => formData.append('files', f));
    }
    const service = this.service;
    service['getCopyAndPayId'](formData).subscribe(
      (res) => {
        this.referencePaymentUrl = `./assets/paymentWidget.html?brand=${this.paymentProvider}&scriptUrl=${res.webUrl}&color=469595`;
        this.dataLoading = false;
      },
      (err) => {
        this.dataLoading = false;
        this.openSnackBar(err.message);
      }
    );

  }

  changeMethod(id) {
    const oldScript = document.getElementById('e-payment-script');
    if (oldScript) {
      this.renderer.removeChild(this.document.body, oldScript);
    }
    const oldForm = document.getElementById('eFinanceForm');

    if (oldForm) {
      oldForm.remove()
    }
    this.getCopyAndPayId();
    // this.dialogRef.close(id);
  }

  openSnackBar(message) {
    this.snackBar.open(message, '✖', {
      duration: 1000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

}
